export const MessageReliabilityCqrsActions = {
    // Inbox actions
    inboxRetry: 'InboxMessageRetryCommand',
    inboxPark: 'InboxMessageParkCommand',
    inboxCancel: 'InboxMessageCancelCommand',
    inboxGetById: 'InboxMessageGetByIdQuery',

    // Outbox actions
    outboxRetry: 'OutboxMessageRetryCommand',
    outboxPark: 'OutboxMessageParkCommand',
    outboxCancel: 'OutboxMessageCancelCommand',
    outboxGetById: 'OutboxMessageGetByIdQuery',
} as const;

export type MessageReliabilityCqrsAction = typeof MessageReliabilityCqrsActions[keyof typeof MessageReliabilityCqrsActions];
